angular.module("app").controller("IosAppSettingsController", [
    '$scope',
    'androidAppService',
    "logger",
    "errorHandler",
    function ($scope, androidAppService, logger, errorHandler) {

        $scope.data = {
            skin_id: "",
            casino_domain: ""
        };
        $scope.tooltip = {
            casino_domain: ""
        };
        $scope.isSkinExist = false;
        var loadedSkinId;
        var app_settings_form;

        $scope.initForm = function initForm(form) {
            app_settings_form = form;
        };

        $scope.loadCasinoDomain = function loadCasinoDomain() {
            if (!$scope.data.skin_id) {
                logger.logError("Please provide partner ID");
                return;
            }
            if ($scope.data.skin_id === loadedSkinId) {
                logger.logError("Partner ID not changed");
                return;
            }
            androidAppService.loadIosCasinoDomain(+$scope.data.skin_id).then(function (response) {
                    if (response.status == 'ok') {
                        $scope.isSkinExist = true;
                        loadedSkinId = $scope.data.skin_id;
                        $scope.data.casino_domain = response.data || "";
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );

        };

        $scope.saveCasinoDomain = function saveCasinoDomain() {
            if (app_settings_form.$valid) {
                androidAppService.saveIosCasinoDomain($scope.data).then(function (response) {
                        if (response.status == 'ok') {
                            logger.logSuccess("global.saved");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                );

            };
        }


    }
]);
